import {global, importFormatManager, lm} from "../../appContext";
import {ImportFormatId} from "../../constants/ImportFormats";
import attribute_name_radioHtml from './attribute-name-radio.html?raw';

export let template: string = attribute_name_radioHtml;

interface IAttributeNameToggleParams {
    importFormatId: ImportFormatId
}

export class viewModel {
    private masterDataSourceName: string;

    constructor(params?: IAttributeNameToggleParams) {
        const importFormat = params?.importFormatId
            ? importFormatManager.getImportFormatById(params.importFormatId)
            : undefined;
        this.masterDataSourceName = importFormat?.name
            ?? global.login.selectedOrganization()?.importformat?.name
            ?? lm.t('Master data source') ?? ''
    }
}
